<div fxLayout="column wrap" fxLayoutAlign="center center" class="wrapper">
  <form (ngSubmit)="submit()" [formGroup]="form" fxLayout="column" ngClass.xs="xs-padding-bar" fxLayoutGap="8px">

    <ifp-company-select></ifp-company-select>

    <mat-form-field appearance="outline">
      <mat-label>Phone number</mat-label>
      <input matInput placeholder="Enter your phone number" autocomplete="tel" required formControlName="phone" mask="(000) 000-0000">
      <mat-error>
        Incorrect phone number.
      </mat-error>
    </mat-form-field>

    <div formGroupName="address" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="8px">
      <ifc-google-places-autocomplete-form-field
        [control]="form.get('address.line1')"
        fieldType="street"
        (placeSelected)="handleAddressChange($event)">
      </ifc-google-places-autocomplete-form-field>

      <mat-form-field appearance="outline" fxFlex>
        <mat-label>Unit/Suite/Apt #</mat-label>
        <input matInput autocomplete="address-line2" formControlName="line2">
      </mat-form-field>

      <div class="address">
        <ifc-google-places-autocomplete-form-field
          [control]="form.get('address.city')"
          fieldType="city"
          cssClass="address__item"
          (placeSelected)="handleCityAddressChange($event)">
        </ifc-google-places-autocomplete-form-field>

        <mat-form-field appearance="outline" class="address__item">
          <mat-select placeholder="State" formControlName="state">
            <mat-option *ngFor="let state of states" [value]="state">
              {{state}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="address__item">
          <mat-label>Zip</mat-label>
          <input matInput placeholder="Enter your zip" autocomplete="postal-code" required formControlName="zip">
          <mat-error>
            Incorrect zip code format.
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="end start" fxLayoutGap="8px">
      <button mat-button routerLink="/home" type="button">Cancel</button>
      <button mat-flat-button color="primary" type="submit"
        [disabled]="submitSub || !form.touched">Save</button>
    </div>

  </form>
</div>
